/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */
import React from 'react';
import styled from 'styled-components';
import { CaretIconSVG } from 'cx-ui-components';

const Expander = styled(CaretIconSVG)`
  width: 10px;
  margin-left: 8px;
`;

// Ripped from ChannelIconSVG with a red pulsing circle added
const NotificationSVG = () => (
  <svg version="1.1" x="0px" y="0px" viewBox="0 0 22.68 22.68" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="rgb(153,153,153)"
      d="M7.71,21.15,6.56,16.53H3.34a2,2,0,0,1-2-2v-10a3,3,0,0,1,3-3h14a3,3,0,0,1,3,3v10a2,2,0,0,1-2,2h-4.7ZM4.34,3.53a1,1,0,0,0-1,1v10H8.12L9,17.91,14,14.53h5.3v-10a1,1,0,0,0-1-1Z"/>
    <circle cx="18" cy="5" r="5" fill="red">
      <animate attributeName="opacity" values="1;0.5;1" dur="1.5s" repeatCount="indefinite"/>
    </circle>
  </svg>
);

export default function() {
  return {
    expander: true,
    Expander: ({ isExpanded, original }) => {
      const hasNewMessages = original.newMessageCount > 0;
      return tableExpander(isExpanded, hasNewMessages);
    }
  };
}

export function tableExpander(isExpanded, hasNewMessages) {
  // Only show notification symbol if we have a new message and details are not expanded
  return (
    <div>
      {isExpanded ? (
        <Expander direction="up" strokeColor="#024f7999" />
      ) : (
        hasNewMessages ? (
          <NotificationSVG />
        ) : (
          <Expander direction="down" strokeColor="#024f7999" />
        )
      )}
    </div>
  );
}
